import { render } from "./EmployeeReport.vue?vue&type=template&id=3051f779"
import script from "./EmployeeReport.vue?vue&type=script&lang=js"
export * from "./EmployeeReport.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__